import { GameType } from '@src/lib/types';
import { Game, ChatMessage, PlayerMeta } from '@src/lib/types';
import { Tournament } from '@src/lib/types';

export enum Stage {
  LOGIN = 'LOGIN',
  LOBBY = 'LOBBY',
  CREATE_GAME = 'CREATE_GAME',
  SHOW_GAME = 'SHOW_GAME',
}

export interface AppState {
  isConnected: boolean;
  playerIsGeoblocked: boolean;
  stage: Stage | null;
  stageMeta: any;
  socketNonce: number;
  showFullViewLoader: boolean;
  chat: {
    [room: string]: ChatMessage[];
  };
  connectedPlayers: number;
  playerMetadata: null | {
    id: number;
    address: string;
    name: string;
    img: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface LobbyState {
  gameTypes: GameType[];
  pendingGameAsHost: {
    gameId: string;
    playerId: string;
  } | null;
}

export interface TournamentState {
  tournaments: {
    [id: string]: Tournament;
  };
}

export interface GameState {
  games: {
    [id: string]: Game;
  };
  chat: {
    [gameId: string]: ChatMessage[];
  };
  playerMeta: PlayerMeta | null;
  currentGameId: string | null;
  watchingGameId: string | null;
  eventQueue: {
    message: string;
    showToast: boolean;
    sound: string | null;
    id: string;
  }[];
}
